<div
  class="u-padding-8 bg-color-white u-border-orange u-borderRadius--4px u-marginBottom-24"
  fxLayout="row"
  fxLayoutAlign="start start"
  fxLayoutGap="8px"
>
  <mat-icon fxFlex="24px" class="color-orange">highlight_off</mat-icon>
  <p i18n="@@groupMatchExclusionsForm.titleDisclaimer">
    {{ account?.full_name }} won't be paired with members that satisfies the
    selected options.
  </p>
</div>
<div class="u-marginBottom-24">
  <div
    class="u-marginBottom-8"
    fxLayout="row"
    fxLayoutGap="4px"
    fxLayoutAlign="start center"
  >
    <mat-icon
      class="md-16 color-grey-300"
      fontSet="material-icons-outlined"
      nz-tooltip="Single select"
      i18n-nz-tooltip="@@global.singleSelect"
      [nzTooltipMouseEnterDelay]="0.3"
      >list_outline</mat-icon
    >
    <p i18n="@@global.roles">Roles</p>
  </div>
  <nz-tree-select
    class="u-display-block u-width-100"
    [nzNodes]="[treeSelectMap.role]"
    [nzVirtualHeight]="
      10 < treeSelectMap.role.children?.length ? '300px' : null
    "
    [(ngModel)]="this.formSelections.roles"
    [nzTreeTemplate]="treeNodeTemplate"
    (ngModelChange)="updateRoleSelection(this.formSelections.roles)"
    nzCheckable
    nzPlaceHolder="No excluded items."
    i18n-nzPlaceHolder="@@groupMatchExclusionsForm.noExcludedItems"
  ></nz-tree-select>
</div>
<div *ngFor="let segment of group.custom_segments" class="u-marginBottom-24">
  <ng-container
    [ngTemplateOutlet]="segmentForm"
    [ngTemplateOutletContext]="{
      segment: segment,
      segmentKey: 'customSegments',
      treeSelectItem: treeSelectMap[segment._id],
    }"
  ></ng-container>
</div>
<div
  *ngFor="let segment of group.hidden_custom_segments"
  class="u-marginBottom-24"
>
  <ng-container
    [ngTemplateOutlet]="segmentForm"
    [ngTemplateOutletContext]="{
      isHiddenSegment: true,
      segment: segment,
      segmentKey: 'hiddenCustomSegments',
      treeSelectItem: treeSelectMap[segment._id],
    }"
  ></ng-container>
</div>
<ng-template
  #segmentForm
  let-isHiddenSegment="isHiddenSegment"
  let-segment="segment"
  let-segmentKey="segmentKey"
  let-treeSelectItem="treeSelectItem"
>
  <div
    class="u-marginBottom-8"
    fxLayout="row"
    fxLayoutGap="4px"
    fxLayoutAlign="start center"
  >
    <ng-container
      [ngTemplateOutlet]="iconTemplate"
      [ngTemplateOutletContext]="{ isHiddenSegment, segment }"
    ></ng-container>
    <p>
      {{ segment.title | translationLookup: ['@@groupCustomSegmentTitle'] }}
    </p>
  </div>
  <nz-tree-select
    class="u-display-block u-width-100"
    [nzNodes]="[treeSelectItem]"
    [nzVirtualHeight]="10 < treeSelectItem.children?.length ? '300px' : null"
    [(ngModel)]="$any(formSelections)[segmentKey][segment._id]"
    [nzTreeTemplate]="treeNodeTemplate"
    (ngModelChange)="
      updateSegmentSelection(
        segmentKey,
        segment,
        $any(formSelections)[segmentKey][segment._id]
      )
    "
    nzCheckable
    nzPlaceHolder="No excluded items."
    i18n-nzPlaceHolder="@@groupMatchExclusionsForm.noExcludedItems"
  ></nz-tree-select>
</ng-template>
<ng-template #treeNodeTemplate let-node="$implicit">
  {{
    node.origin.title
      | translationLookup: ['@@groupRole', '@@groupCustomSegmentOption']
  }}
</ng-template>
<ng-template
  #iconTemplate
  let-isHiddenSegment="isHiddenSegment"
  let-segment="segment"
>
  <ng-container [ngSwitch]="isHiddenSegment">
    <ng-container *ngSwitchCase="true">
      <mat-icon
        class="md-16 color-grey-300"
        fontSet="material-icons-outlined"
        nz-tooltip="Private segment"
        i18n-nz-tooltip="@@global.privateSegment"
        [nzTooltipMouseEnterDelay]="0.3"
        >visibility_off</mat-icon
      >
    </ng-container>
    <ng-container *ngSwitchDefault>
      <mat-icon
        *ngIf="'single' === segment.selection_type; else multipleSelection"
        class="md-16 color-grey-300"
        fontSet="material-icons-outlined"
        nz-tooltip="Single select"
        i18n-nz-tooltip="@@global.singleSelect"
        [nzTooltipMouseEnterDelay]="0.3"
        >arrow_drop_down_circle
      </mat-icon>
      <ng-template #multipleSelection>
        <mat-icon
          class="md-16 color-grey-300"
          fontSet="material-icons-outlined"
          nz-tooltip="Multi select"
          i18n-nz-tooltip="@@global.multiSelect"
          [nzTooltipMouseEnterDelay]="0.3"
          >list_outline</mat-icon
        >
      </ng-template>
    </ng-container>
  </ng-container>
</ng-template>
